import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { type ChildRouteContext } from "@/root";

import News from "@/modules/news/user/components/News";
import { fetchNewsQueryOptions } from "@/modules/news/user/services";

export const Route = createFileRoute("/_panel/_news/news/$id")({
  component: Component,
  parseParams: (params) => ({
    id: z.number().int().parse(Number(params.id)),
  }),
  beforeLoad: ({ context }) =>
    ({
      crumb: [
        {
          label: context.t("View news", { ns: "news.user" }),
        },
      ],
    }) satisfies ChildRouteContext,
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(
      fetchNewsQueryOptions(opts.params.id),
    ),
  stringifyParams: ({ id }) => ({ id: `${id}` }),
});

function Component() {
  const { id } = Route.useParams();

  return <News id={id} />;
}
